import { createContext } from "react";

export const FF = "'Avenir','Avenir Book','Nunito Variable',sans-serif";
export const FF_ENERGY = FF;

/** Maps meterId → human-readable label from site coverProps */
export const MeterLabelsCtx = createContext<Record<string,string>>({});

/**
 * Résolution PDL ELEC → source ("enedis"|"deepki"), pour router chaque bloc énergie vers le bon
 * endpoint (cf. src/api/energyApi.ts). Alimenté une fois par ReportA4.tsx depuis metersApi.listPdl()
 * (fetch global, pas par site — un même report mensuel-multi référence plusieurs siteId différents
 * dans ses blocs, chacun avec ses propres PDL). `idsBySite` sert à résoudre "total" (tous les PDL
 * du site d'un bloc) sans dépendre de coverPropsState (qui ne décrit que le site "principal" du
 * rapport, absent en mode mensuel-multi). Un PDL absent de `sourceById` = source non configurée.
 */
export interface ElecMetersInfo {
  idsBySite:  Record<string, string[]>;
  sourceById: Record<string, "enedis" | "deepki" | "engie" | undefined>;
}
export const ElecMetersCtx = createContext<ElecMetersInfo>({ idsBySite: {}, sourceById: {} });

/**
 * Résolution PCE GAZ → source ("grdf"|"engie"), même principe que ElecMetersCtx — cf. CLAUDE.md,
 * section "Migration ÉLEC + GAZ vers ts-ingest". Alimentée une fois par ReportA4.tsx depuis
 * metersApi.listPce(). Un PCE absent de `sourceById` (source==="") = source non configurée.
 */
export interface GazMetersInfo {
  idsBySite:  Record<string, string[]>;
  sourceById: Record<string, "grdf" | "engie" | undefined>;
}
export const GazMetersCtx = createContext<GazMetersInfo>({ idsBySite: {}, sourceById: {} });
